import { render } from "./Toaster.vue?vue&type=template&id=223a1886"
import script from "./Toaster.vue?vue&type=script&lang=js"
export * from "./Toaster.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src834291806/src/oms-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__